import { FC } from 'react';

const Form: FC = ({ children }) => <div>{children}</div>;

export { Form };
